"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@mui/styles");

var _material = require("@mui/material");

var StyledStepTitle = (0, _styles.styled)(_material.Typography)(function (_ref) {
  var _ref$theme = _ref.theme,
      palette = _ref$theme.palette,
      spacing = _ref$theme.spacing;
  return {
    fontSize: '1.375rem',
    lineHeight: '1.65rem',
    fontWeight: 700,
    color: palette.primary.main,
    padding: spacing(4, 0),
    textAlign: 'center'
  };
});
var _default = StyledStepTitle;
exports.default = _default;